<template>
  <div>

    <div class="box">

      <div class="flex flex-wrap items-center">
        <div class="flex-grow mb-1">
          <list-search v-model="searchInput" @search="get"/>
          <p class="text-xs mt-0 ml-1" v-if="query.search !== ''">
            Searching for <span class="text-red-500 font-bold">{{ query.search }}</span>
          </p>
        </div>

        <div class="flex">
          <div
            v-if="hasPermission('user.create')"
            class="btn btn-purple text-sm mr-2 h-10 flex items-center px-3 mb-1"
            @click="$router.push('/administration/user/create')"
          >
            <i class="fas fa-plus"></i>
            <span class="ml-2">New user</span>
          </div>

          <button class="btn w-10 h-10 flex items-center justify-center focus:outline-none hover:text-green-500 mb-1" @click="get">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap justify-center">
        <p class="text-lg text-center my-12" v-if="!hasUsers">No data to display</p>
        <div class="w-full overflow-x-auto" v-else>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Created at</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, i) in users" :key="i">
                <td class="font-bold">{{ user.id }}</td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.roles.map(r => r.name).join(',') }}</td>
                <td>
                  {{ $moment(user.created_at).format(config.dateTimeFormats.display) }}
                </td>
                <td>
                  <div class="flex">
                    <a
                      class="hover:text-theme-darker text-base cursor-pointer p-2"
                      @click.stop="$router.push('/administration/user/details/' + user.id)"
                    ><i class="fas fa-info"></i></a>
                    <a
                      class="hover:text-theme-darker text-base cursor-pointer p-2"
                      @click.stop="$router.push('/administration/user/edit/' + user.id)"
                    ><i class="fas fa-edit"></i></a>
                    <a
                      class="hover:text-theme-darker text-base cursor-pointer p-2"
                      @click.stop="deleteUser(user.id)"
                      v-if="user.id !== User.id"
                    ><i class="fas fa-trash"></i></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="w-full flex justify-center">
          <pagination-component
            class="mt-8"
            v-if="hasUsers && pagination.totalRows / pagination.perPage > 1"
            v-model="pagination.currentPage"
            :total-rows="pagination.totalRows"
            :rows-per-page="pagination.perPage"
          />
        </div>

      </div>

    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const ListSearch = resolve => require(['@/components/ListSearch'], resolve)
const PaginationComponent = resolve => require(['@/components/Pagination'], resolve)

export default {
  components: {
    ListSearch,
    PaginationComponent,
  },
  data() {
    return {
      users: [],
      query: {
        search: '',
      },
      searchInput: '',
      pagination: {
        currentPage: 1,
        totalRows: 0,
        perPage: 0,
      }
    }
  },
  watch: {
    'pagination.currentPage'() {
      this.get()
    },
  },
  computed: {
    hasUsers() {
      return Object.entries(this.users).length > 0
    },
    ...mapGetters({
      User: 'user/user',
      config: 'config/config',
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.get()
  },
  methods: {
    deleteUser(userID) {
      this.$swal.fire({
        title: 'Delete user',
        text: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      })
        .then((result) => {
          if (result.value) {
            axios.delete('users/' + userID)
              .then(() => {
                this.$swal.fire('Delete successful', '', 'success')
                this.get()
              })
          }
        })
    },
    get() {
      axios.get('users', {params:{
        page: this.pagination.currentPage,
        search: this.searchInput,
      }})
        .then(response => {
          const res = response.data
          this.pagination.perPage = res.per_page
          this.pagination.totalRows = res.total

          this.users = Object.assign([], res.data)

          this.query.search = this.searchInput
        })
    }
  }
}
</script>
